export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="space-y-6">
            <div className="inline-block">
              <span className="text-pink-400 text-sm font-semibold tracking-wider uppercase">About Us</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-white leading-tight">
              Where Music<br />Meets Magic
            </h2>
            <p className="text-lg text-gray-200 leading-relaxed">
              Gang Nam Style Karaoke is Duluth's premier karaoke destination, offering an unforgettable entertainment experience since our opening. We combine state-of-the-art sound systems, vibrant atmosphere, and exceptional service to create the perfect night out.
            </p>
            <p className="text-lg text-gray-200 leading-relaxed">
              Whether you're celebrating a special occasion, hosting a corporate event, or just looking for a fun night with friends, our venue provides the perfect backdrop. With private rooms, open stage nights, and a full bar featuring craft cocktails and Korean-inspired bites, every visit is a celebration.
            </p>
            <div className="grid grid-cols-3 gap-8 pt-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-pink-400">7</div>
                <div className="text-sm text-gray-300 mt-2">Days Open</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-pink-400">8</div>
                <div className="text-sm text-gray-300 mt-2">Hours Daily</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-pink-400">1000+</div>
                <div className="text-sm text-gray-300 mt-2">Songs</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/f7394204ca1d00c1ae2dcd0f605f00fb.jpg"
                alt="Private Karaoke Room"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-pink-600 text-white p-8 rounded-2xl shadow-xl">
              <div className="text-3xl font-bold">5 PM - 1 AM</div>
              <div className="text-sm mt-1">Open Every Day</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
